import React from "react";

export const stageStatusColor = (s) => {
  if (s === "NORMAL")  return { color: "#10b981", bg: "#d1fae5", border: "#10b981", label: "Normal"  };
  if (s === "WARNING") return { color: "#f59e0b", bg: "#fef3c7", border: "#f59e0b", label: "Warning" };
  if (s === "ALARM")   return { color: "#ef4444", bg: "#fee2e2", border: "#ef4444", label: "Alarm"   };
  return                      { color: "#6b7280", bg: "#f3f4f6", border: "#6b7280", label: s };
};

export const complianceColor = (val, min, max) => {
  if (min !== undefined && val < min) return "#ef4444";
  if (max !== undefined && val > max) return "#ef4444";
  const range = max - (min || 0);
  const margin = (max - val) / range;
  if (margin < 0.15) return "#f59e0b";
  return "#10b981";
};

export const pumpStatusColor = (s) => {
  if (s === "Running")  return { color: "#10b981", bg: "#d1fae5" };
  if (s === "Standby")  return { color: "#3b82f6", bg: "#dbeafe" };
  if (s === "Idle")     return { color: "#6b7280", bg: "#f3f4f6" };
  if (s === "Fault")    return { color: "#ef4444", bg: "#fee2e2" };
  return { color: "#6b7280", bg: "#f3f4f6" };
};

export const riskColor = (r) => {
  if (r >= 50) return "#ef4444";
  if (r >= 25) return "#f59e0b";
  return "#10b981";
};

export const severityColor = (s) => {
  if (s === "Critical") return { color: "#ef4444", bg: "#fee2e2" };
  if (s === "Warning")  return { color: "#f59e0b", bg: "#fef3c7" };
  return { color: "#3b82f6", bg: "#dbeafe" };
};

export const blowerStatusColor = (s) => {
  if (s === "Running")  return { color: "#10b981", bg: "#d1fae5" };
  if (s === "Standby")  return { color: "#3b82f6", bg: "#dbeafe" };
  if (s === "Offline")  return { color: "#ef4444", bg: "#fee2e2" };
  return { color: "#6b7280", bg: "#f3f4f6" };
};

export const KpiCard = ({ label, value, unit, color, icon: Icon, sub, alert, onClick }) => (
  <div className="stp-kpi-card" style={{ borderTopColor: color }} onClick={onClick}>
    <div className="stp-kpi-top">
      {Icon && <div className="stp-kpi-icon" style={{ background: color + "18" }}><Icon size={18} color={color} /></div>}
      <div>
        <div className="stp-kpi-value" style={{ color }}>{value}<span className="stp-kpi-unit"> {unit}</span></div>
        <div className="stp-kpi-label">{label}</div>
      </div>
    </div>
    {sub   && <div className="stp-kpi-sub">{sub}</div>}
    {alert && <div className="stp-kpi-alert">{alert}</div>}
  </div>
);

export const StatusBadge = ({ status }) => {
  const st = stageStatusColor(status);
  return <span className="stp-badge" style={{ background: st.bg, color: st.color }}>{st.label}</span>;
};

export const PumpBadge = ({ status }) => {
  const st = pumpStatusColor(status);
  return <span className="stp-badge" style={{ background: st.bg, color: st.color }}>{status}</span>;
};

export const SeverityBadge = ({ severity }) => {
  const st = severityColor(severity);
  return <span className="stp-badge" style={{ background: st.bg, color: st.color }}>{severity}</span>;
};

export const MiniBar = ({ value, max, color, height = 6 }) => (
  <div style={{ background: "#f3f4f6", borderRadius: 4, height, overflow: "hidden", width: "100%", minWidth: 60 }}>
    <div style={{ width: `${Math.min(100, (value / max) * 100)}%`, background: color, height: "100%", borderRadius: 4 }} />
  </div>
);

export const HealthRing = ({ score, size = 80 }) => {
  const r = (size - 14) / 2;
  const circ = 2 * Math.PI * r;
  const fill = (score / 100) * circ;
  const color = score >= 80 ? "#10b981" : score >= 60 ? "#f59e0b" : "#ef4444";
  return (
    <svg width={size} height={size}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f3f4f6" strokeWidth={10} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={10}
        strokeDasharray={`${fill} ${circ - fill}`} strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      <text x="50%" y="50%" textAnchor="middle" dy="0.35em" fontSize={size * 0.22} fontWeight="700" fill={color}>{score}</text>
    </svg>
  );
};

export const TankLevel = ({ level, height = 60, width = 32, color }) => {
  const fillColor = color || (level > 80 ? "#ef4444" : level > 60 ? "#f59e0b" : level < 20 ? "#ef4444" : "#3b82f6");
  return (
    <div style={{ width, height, border: "2px solid #d1d5db", borderRadius: 4, overflow: "hidden", background: "#f9fafb", position: "relative", flexShrink: 0 }}>
      <div style={{ position: "absolute", bottom: 0, width: "100%", height: `${level}%`, background: fillColor, opacity: 0.7, transition: "height 0.5s", borderRadius: "0 0 2px 2px" }} />
      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", fontSize: 9, fontWeight: 700, color: "#374151", zIndex: 1 }}>{level}%</div>
    </div>
  );
};
